import {
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  RegisterService,
  UserService,
} from 'src/app/services';
import { DialogResult, User } from 'src/app/types';

@Component({
  selector: 'app-edit-email-dialog',
  templateUrl: './edit-email-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class EditEmailDialogComponent implements OnInit {
  result: DialogResult | null = null;
  private form!: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: RegisterService,
    private userService: UserService,
    public bsModalRef: BsModalRef<EditEmailDialogComponent>
  ) {}

  close(): void {
    this.bsModalRef.hide();
  }

  get emailControl(): UntypedFormControl {
    return this.form.get('email') as UntypedFormControl;
  }

  get user(): User {
    return this.userService.formState.item as User;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submit() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.service
      .editEmail(this.emailControl.value, this.user)
      .then(() => {
        this.result = { success: true };
        this.bsModalRef.hide();
      })
      .catch(() => {
        this.result = { success: false };
        this.bsModalRef.hide();
      });
  }
}
